export default __webpack_public_path__ + "static/media/KZ.T.19.2276 black.e7455c99.svg";